module.exports = __webpack_public_path__ + "static/media/women.5b249ef3.png";